<main *ngIf="company$ | async as company" class="container">
  <article *ngIf="job$ | async as job" class="content" itemscope itemtype="http://schema.org/JobPosting">
    <!-- Raw model.createdDate because pipe date does not seem to work well with SSR -->
    <meta *ngIf="job?.datePublished" itemprop="datePosted" [content]="job?.datePublished" />
    <meta *ngIf="company.logo" itemprop="image" [content]="company.logo" />
    <meta *ngIf="job.remote" itemprop="jobLocationType" content="TELECOMMUTE" />
    <span wizHeadTitle>{{ job.title }} - {{ company.name }}</span>
    <span i18n wizHeadDescription>
      {{ company.name }} recrute ! Consultez toutes nos offres d'emploi et postulez en ligne.
    </span>

    <header class="header" [@staggerAnimation]>
      <app-logo
        class="header__logo"
        size="large"
        background="#ffffff"
        color="#8782ff"
        [item]="{
          logoUrl: company.logo,
          companyName: company.name
        }"
      ></app-logo>

      <span itemprop="hiringOrganization" itemscope itemtype="http://schema.org/Organization">
        <a
          class="header__company-name"
          [routerLink]="['/']"
          itemprop="name"
          appEventTracker
          eventCategory="Job"
          eventCategory="Click Company Name"
          >{{ company.name }}</a
        >
      </span>

      <div class="header__helpers">
        <a
          [routerLink]="['/']"
          class="btn-clean header-button"
          appEventTracker
          eventCategory="Job"
          eventAction="Click Back"
        >
          <svg-icon class="header-button__icon" icon="exp-chevron-down" height=".4em" width=".8em"></svg-icon>
          <span i18n>Nos offres</span>
        </a>

        <span class="share">
          <app-job-share-popup [job]="job"></app-job-share-popup>
        </span>
      </div>

      <h1 itemprop="title" class="header__title">{{ job.title }}</h1>

      <div class="keywords">
        <span itemprop="employmentType" *ngIf="job.contract" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-briefcase" width="1em"></svg-icon>
          <i18n-contract [model]="job.contract"></i18n-contract>
        </span>

        <span *ngIf="job.duration && job.duration !== durationEnum.Undetermined" class="keyword">
          <svg-icon class="keyword__icon" icon="clock" width="1em"></svg-icon>
          <i18n-contract-duration [model]="job.duration"></i18n-contract-duration>
        </span>

        <app-location [job]="job"></app-location>

        <span *ngIf="job.startDate" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-calendar" width="1em"></svg-icon>
          <span class="header__tag">{{ job.startDate | date }}</span>
        </span>

        <span
          itemprop="experienceRequirements"
          *ngIf="job.profileStudyLevel && job.profileStudyLevel !== studyLevelEnum.Any"
          class="keyword"
        >
          <svg-icon class="keyword__icon" icon="diplome" width="1em"></svg-icon>
          <i18n-study-level [model]="job.profileStudyLevel"></i18n-study-level>
        </span>

        <span itemprop="industry" *ngIf="job.domain" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-price-tag" width="1em"></svg-icon>
          <i18n-domain [model]="job.domain"></i18n-domain>
        </span>

        <app-salary [salaryMin]="job.salaryMin" [salaryMax]="job.salaryMax"> </app-salary>

        <span *ngIf="job.remote" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-laptop" width="1em"></svg-icon>
          <ng-container i18n>Télétravail</ng-container>
        </span>

        <span *ngIf="job.profileExperience && job.profileExperience !== experienceEnum.Any" class="keyword">
          <svg-icon class="keyword__icon" icon="exp-joystick" width="1em"></svg-icon>
          <i18n-experience [model]="job.profileExperience"></i18n-experience>
        </span>
      </div>

      <div class="tags" *ngIf="job.skills">
        <span itemprop="skills" class="tags__item" *ngFor="let skill of job.skills; trackBy: trackByLabel">{{
          skill | titlecase
        }}</span>
      </div>

      <button
        class="action btn"
        [routerLink]="[jobRoutingEnum.JobApply]"
        appEventTracker
        eventCategory="Job"
        eventAction="Click Apply"
        eventLabel="Top"
      >
        <ng-container i18n>Postuler Maintenant</ng-container>
        <svg-icon class="action__icon" icon="exp-chevron-down" height=".5em" width=".6em"></svg-icon>
      </button>
    </header>

    <app-description *ngIf="job" [description]="job.description" [status]="job.status"></app-description>

    <app-profil [profil]="job.profileDescription"></app-profil>

    <section *ngIf="company.slogan || company.description" class="content__jobs" id="home-anchor">
      <h2 *ngIf="company.slogan" class="content__title">{{ company.slogan }}</h2>
      <p *ngIf="company.description" class="content__description">{{ company.description }}</p>
    </section>

    <footer class="content__jobs__control">
      <button
        class="action btn"
        [routerLink]="[jobRoutingEnum.JobApply]"
        appEventTracker
        eventCategory="Job"
        eventAction="Click Apply"
        eventLabel="Bottom"
      >
        <ng-container i18n>Postuler Maintenant</ng-container>
        <svg-icon class="action__icon" icon="exp-chevron-down" height=".5em" width=".6em"></svg-icon>
      </button>
    </footer>
  </article>

  <app-footer location="Job"></app-footer>
</main>
